// 首页页面接口
import axios from '@/utils/http'
import Url from './requestUrl'
import Qs from 'qs'

// 通过尽调编号查询尽调任务
export function querySurveyBySurveyNo(params) {
  return axios({
    url: Url.querySurveyBySurveyNoUrl,
    method: 'get',
    params
  })
}

// 获取当前登录用户的调研任务列表
export function getSurveyList(data) {
  return axios({
    baseURL: 'http://mstest.jr.jd.com',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: Url.getSurveyListJDJRUrl,
    method: 'post',
    data
  })
}

// 根据问卷编号查询问卷分类
export function getCategoryList(params) {
  return axios({
    url: Url.getCategoryListUrl,
    method: 'get',
    params
  })
}

// 根据问卷编号、分类编码查询问题列表
export function getQuestionList(params) {
  return axios({
    url: Url.getQuestionListUrl,
    method: 'get',
    params
  })
}

// 查询答案列表
export function queryAnswerDetail(params) {
  return axios({
    url: Url.queryAnswerDetailUrl,
    method: 'get',
    params
  })
}

// 上传文件
export function uploadFile(data) {
  return axios({
    url: Url.uploadFileUrl,
    method: 'post',
    data
  })
}

// 查看已上传文件
export function getURLByFileNo(params) {
  return axios({
    url: Url.getURLByFileNoUrl,
    method: 'get',
    params
  })
}

// 单个删除附件，增加权限控制
export function deleteFileByFileNo(data) {
  return axios({
    url: Url.deleteFileByFileNoUrl,
    method: 'post',
    data
  })
}

// 保存答案
export function saveAnswerSurvey(data) {
  return axios({
    url: Url.saveAnswerSurveyUrl,
    method: 'post',
    data
  })
}

// 提交任务
export function commitSurvey(data) {
  return axios({
    url: Url.commitSurveyUrl,
    method: 'post',
    data
  })
}

// 检查是否存在未答的必答题
export function checkRequiredCategory(params) {
  return axios({
    url: Url.checkRequiredCategoryUrl,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/http/jdjrSurvey.js